import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { useEffect } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import i18next from 'i18next';
import AddingButton from '../../AddingButton';
import { PrivilegeEnum } from '../../../../services/common/RolesUtils';
import ContactsDataTable from '../../../../containers/tp-contacts/contacts-list/ContactsDataTable';
import UserCreationDialog from '../../../../containers/users/users-list/UserCreationDialog';

function ContactSection({ display,
                          title,
                          tpVisibleContactsCount,
                          contacts,
                          setIsCreateContactDialogOpen,
                          hasAnyOfPrivilegesOnScopedResource,
                          loaderContacts,
                          fetchContacts,
                          setTpVisibleContactsCount,
                          thirdpartyId,
                          isCreateContactDialogOpen,
                          thirdparty,
                          onReinviteUser,
                          concactsDataTableRef}) {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(contacts?.length);
  }, [contacts]);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"contacts"}>
      <EAAccordion
        title={i18next.t('contactsTable.title')}
        logo="contacts"
        counter={
          tpVisibleContactsCount !== null
            ? tpVisibleContactsCount
            : contacts?.length
        }
        totalCount={contacts?.length}
        opened={isExpanded}
        buttons={[
          <AddingButton
            label={i18next.t('contactsTable.createBtnLabel')}
            handleClick={() => setIsCreateContactDialogOpen(true)}
            disabled={
              !hasAnyOfPrivilegesOnScopedResource(
                PrivilegeEnum.PRIVILEGE_CREATE_CONTACT
              )
            }
          />,
        ]}
      >
        <ContactsDataTable
          loader={loaderContacts}
          contacts={contacts}
          onContactsDeleted={() => fetchContacts()}
          onContactsCreated={() => fetchContacts()}
          tpOid={thirdpartyId}
          pageSize={10}
          multiDataGridPage
          sheetVariant={true}
          onVisibleRowsCountChange={(count) =>
            setTpVisibleContactsCount(count)
          }
          ref={concactsDataTableRef}
        />
      </EAAccordion>

      {isCreateContactDialogOpen &&
        hasAnyOfPrivilegesOnScopedResource(
          PrivilegeEnum.PRIVILEGE_CREATE_CONTACT
        ) && (
          <UserCreationDialog
            isOpen={isCreateContactDialogOpen}
            handleClose={() => setIsCreateContactDialogOpen(false)}
            handleOnCreate={() => fetchContacts()}
            tpContact={true}
            tpId={thirdparty.thirdpartyId}
            onReinviteUser={onReinviteUser}
            userType={"contact"}
            thirdparty={thirdparty}
          />
        )}
    </Grid>
  );
}

export default ContactSection;
